import { apiSlice } from 'store/slices/api/api-slice';
import {
    CardsPersonageRequest,
    EditPersonageResponse,
} from 'types/card/card-personage-list';

export const editPersonageApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPersonageData: builder.query<EditPersonageResponse, string>({
            query: (params: string) => ({
                url: `/personage/personage/${params}`,
                method: 'GET',
            }),
        }),
        editPersonage: builder.mutation<void, CardsPersonageRequest>({
            query: (cardsPersonageRequest: CardsPersonageRequest) => ({
                url: `/personage/update/${cardsPersonageRequest.cardSphereId}`,
                method: 'PUT',
                body: { ...cardsPersonageRequest },
            }),
        }),
    }),
});

export const { useGetPersonageDataQuery, useEditPersonageMutation } =
    editPersonageApi;
